import { QueryResult, useQuery } from '@apollo/client'
import { PYRAMID_VALUES_AND_REFERENCE_PYRAMID } from '../Queries'
import {
  PyramidValuesAndReferencePyramidsQuery,
  PyramidValuesAndReferencePyramidsQueryVariables,
  Country,
  PyramidType,
} from '../../../types'

export default (
  companyId: string,
  country: Country,
  type: PyramidType,
): QueryResult<PyramidValuesAndReferencePyramidsQuery, PyramidValuesAndReferencePyramidsQueryVariables> => {
  const variables = {
    companyId: companyId,
    country: country,
    pyramidType: type,
  }
  return useQuery<PyramidValuesAndReferencePyramidsQuery, PyramidValuesAndReferencePyramidsQueryVariables>(
    PYRAMID_VALUES_AND_REFERENCE_PYRAMID,
    {
      variables: variables,
      fetchPolicy: 'network-only',
    },
  )
}
